import AddCardOpenPay from './AddCardOpenPay';
export default AddCardOpenPay;